import {

    GETKNOWLEDGETRANSFERMAINTITLE,
    CREATEKNOWLEDGETRANSFERMAINTITLE,
    UPDATEKNOWLEDGETRANSFERMAINTITLE,
    DELETEKNOWLEDGETRANSFERMAINTITLE,

    UPLOADKTDOCUMENT,
    DELETEKTDOCUMENT,
    GETKNOWLEDGETRANSFER,
    CREATEKNOWLEDGETRANSFER,
    UPDATEKNOWLEDGETRANSFER,
    DELETEKNOWLEDGETRANSFER,

    COPYPROJECT,
    CREATEPROJECT,
    CREATEPROJECTGROUP,
    CREATEPROJECTMODULE,
    DELETEPROJECT,
    DELETEPROJECTGROUP,
    DELETEPROJECTMODULE,
    GETPROJECT,
    GETPROJECTGROUP,
    GETPROJECTMODULE,
    UPDATEPROJECT,
    UPDATEPROJECTGROUP,
    UPDATEPROJECTMODULE,
    GETPROJECTTASK,
    UPDATEPROJECTTASK,
    CREATEPROJECTTASK,
    DELETEPROJECTTASK,
    CREATEPROJECTISSUE,
    GETPROJECTISSUE,
    UPDATEPROJECTISSUE,
    DELETEPROJECTISSUE,
    GETALLPROJECTISSUE,
    GETALLPROJECTTASK,
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case COPYPROJECT:
            return {
                ...state,
                CopyprojectSaveStatus: action.payload.success,
            }
        case CREATEPROJECT:
            return {
                ...state,
                projectSaveStatus: action.payload.success,
            }
        case GETPROJECT:
            return {
                ...state,
                projectList: action.payload.data,
            }
        case UPDATEPROJECT:
            return {
                ...state,
                projectUpdateStatus: action.payload.success,
            }

        case DELETEPROJECT:
            return {
                ...state,
                projectDeleteStatus: action.payload.success,
            }
        case CREATEPROJECTMODULE:
            return {
                ...state,
                projectmoduleSaveStatus: action.payload.success,
            }
        case GETPROJECTMODULE:
            return {
                ...state,
                projectmoduleList: action.payload.data,
            }
        case UPDATEPROJECTMODULE:
            return {
                ...state,
                projectmoduleUpdateStatus: action.payload.success,
            }

        case DELETEPROJECTMODULE:
            return {
                ...state,
                projectmoduleDeleteStatus: action.payload.success,
            }
        case CREATEPROJECTGROUP:
            return {
                ...state,
                projectgroupSaveStatus: action.payload.success,
            }
        case GETPROJECTGROUP:
            return {
                ...state,
                projectgroupList: action.payload.data,
            }
        case UPDATEPROJECTGROUP:
            return {
                ...state,
                projectgroupUpdateStatus: action.payload.success,
            }

        case DELETEPROJECTGROUP:
            return {
                ...state,
                projectgroupDeleteStatus: action.payload.success,
            }
        case CREATEPROJECTTASK:
            return {
                ...state,
                projecttaskSaveStatus: action.payload.success,
            }
        case GETPROJECTTASK:
            return {
                ...state,
                projecttaskList: action.payload.data,
            }
        case GETALLPROJECTTASK:
            return {
                ...state,
                allprojecttaskList: action.payload.data,
            }

        case UPDATEPROJECTTASK:
            return {
                ...state,
                projecttaskUpdateStatus: action.payload.success,
            }

        case DELETEPROJECTTASK:
            return {
                ...state,
                projecttaskDeleteStatus: action.payload.success,
            }
        case CREATEPROJECTISSUE:
            return {
                ...state,
                projectissueSaveStatus: action.payload.success,
            }
        case GETPROJECTISSUE:
            return {
                ...state,
                projectissueList: action.payload.data,
            }
        case GETALLPROJECTISSUE:
            return {
                ...state,
                allprojectissueList: action.payload.data,
            }
        case UPDATEPROJECTISSUE:
            return {
                ...state,
                projectissueUpdateStatus: action.payload.success,
            }

        case DELETEPROJECTISSUE:
            return {
                ...state,
                projectissueDeleteStatus: action.payload.success,
            }

        case CREATEKNOWLEDGETRANSFER:
            return {
                ...state,
                knowledgetransferSaveStatus: action.payload.success,
            }
        case GETKNOWLEDGETRANSFER:
            return {
                ...state,
                knowledgetransferList: action.payload.data,
            }
        case UPDATEKNOWLEDGETRANSFER:
            return {
                ...state,
                knowledgetransferUpdateStatus: action.payload.success,
            }

        case DELETEKNOWLEDGETRANSFER:
            return {
                ...state,
                knowledgetransferDeleteStatus: action.payload.success,
            }
        case CREATEKNOWLEDGETRANSFERMAINTITLE:
            return {
                ...state,
                knowledgetransferMainTitleSaveStatus: action.payload.success,
            }
        case GETKNOWLEDGETRANSFERMAINTITLE:
            return {
                ...state,
                knowledgeTransferMainTitleList: action.payload.data,
            }
        case UPDATEKNOWLEDGETRANSFERMAINTITLE:
            return {
                ...state,
                knowledgetransferMainTitleUpdateStatus: action.payload.success,
            }

        case DELETEKNOWLEDGETRANSFERMAINTITLE:
            return {
                ...state,
                knowledgetransferMainTitleDeleteStatus: action.payload.success,
            }

        case UPLOADKTDOCUMENT:
            return {
                ...state,
                UploadKTDocumentsStatus: action.payload.success,
            }

        case DELETEKTDOCUMENT:
            return {
                ...state,
                KTDocumentsDeleteStatus: action.payload.success,
            }

        default:
            return state
    }
}